@if (fullName()) {
  <div class="billing-name-warning">
    <ac-icon iconKey="hr:warning" class="billing-name-warning__icon" />
    <span class="ac-body-sm billing-name-warning__text">
      The name on this card must be {{ fullName() }}. If there is a name mismatch, the purchase will fail.
    </span>
  </div>
}
